module.exports = __webpack_public_path__ + "img/icon_circle.848e2c14.svg";